var $ = require('jquery');
var Isotope = require('isotope-layout');
var InfiniteScroll = require('infinite-scroll');

window.$ = $;
window.jQuery = $;

/**
 * Holder application specific
 */
(function ($) {

    $(document).ready(function () {
        /**
         * Resource Library
         */
        $('#resource-library').each(function() {
            var $library = $(this);
            var $filter = $('#resource-filter')

            var $podList = $library.find('.pod-list');

            // Setup filter for each group
            var $filter_result = $filter.find('.filter-result');

            var filterRequest = null;
            var filtersStorage = null;
            var filters = {};

            var iso;
            var infScroll;

            $library.addClass('initilize loading')
            $filter.addClass('loading')

            // Use local store if no filters
            if (window.localStorage && !window.location.href.includes('?')) {
                filtersStorage = window.localStorage.getItem('resource-library');
                if (filtersStorage) {
                    filters = JSON.parse(filtersStorage);

                    if (filters.search) {
                        delete filters.search;
                    }
                }
            }

            function setFilterValue(type, value) {
                if (!filters[type]) {
                    filters[type] = [];
                }

                if (typeof value !== 'undefined') {
                    if (type == 'search') {
                        filters.search = value;
                    } else {
                        if (value && filters[type].indexOf(value) === -1) {
                            filters[type].push(value);
                        }
                    }
                }

                if (window.localStorage) {
                    var savedFilter = filters;
                    window.localStorage.setItem('resource-library', JSON.stringify(savedFilter));
                }
            }

            function updateFilterFields() {
                for (var type in filters) {
                    for (var i = 0; i < filters[type].length; i++) {
                        // Check group exists
                        var $filter_group = $filter_result.find('[data-group="' + type + '"]');
                        if ($filter_group.length == 0) {
                            $filter_result.append("<div class='filter-type' data-group='" + type + "'><span class='filter-label'>" + type + ":</span> </div>");
                            $filter_group = $filter_result.find('[data-group="' + type + '"]');
                        }

                        // Append element if not exists
                        var $filter_input = $filter_result.find('[data-type="' + type + '"][value="' + filters[type][i] + '"]');

                        if ($filter_input.length == 0) {
                            var formname = (type == 'type') ? 'filter_type' : 'filter_category';
                            var value = filters[type][i];
                            var label = $filter.find('.dropdown[data-filter="' + type + '"] .dropdown-filter > [data-value="' + value + '"]').text();
                            if (label && value) {
                                $filter_group.append(
                                    '<div class="filter-item"><input type="hidden" id="filter-' + type + '-' + value + '" name="' + formname + '[]" data-type="' + type + '" value="' + value + '" /></div>'
                                )

                                // Attach event to newly added button
                                var $removeBtn = $('<button class="remove-btn" type="button">' + label + ' <span>x</span></button>');
                                $removeBtn.on('click', removeFilter);
                                $removeBtn.insertAfter('#filter-' + type + '-' + value + '')
                            }
                        }
                    }

                    // Check for empty groups
                    $filter_result.find('.filter-type').each(function () {
                        if ($(this).children().length == 1) {
                            $(this).remove();
                        }
                    })
                }
            }

            if ($podList.length) {
                iso = new Isotope($podList[0],  {
                    itemSelector: '.resource-item',
                    layoutMode: 'fitRows',
                    fitRows: {
                        gutter: '.gutter-sizer',
                        columnWidth: '.grid-sizer',
                    },
                    percentPosition: true,
                    getSortData: {
                        date: '[data-date] parseInt'
                    },
                    sortBy: 'date',
                    sortAscending: false
                });

                // ISO event - Triggered after a layout and all positioning transitions have completed.
                iso.on('layoutComplete', function (laidOutItems) {
                    $filter.addClass('completed')
                    $library.addClass('completed')
                });
            }

            // Setup Infinite Scrolling
            function setupScrolling() {
                var $paginator = $library.find('#pods-paginator');
                if ($paginator.find('.pagination__next').length) {

                    var scrollOptions = {
                            history: false, // Disable changines to URL and browser history.
                            path: '.pagination__next',
                            status: '.results-status',    // selector for the paged navigation
                            itemSelector: '.resource-item',     // selector for all items you'll retrieve
                        },
                        scrollCallback = function (document) {
                            var $html = $(document.body)

                            // Remove duplicates
                            var $items = $html.find('.resource-item').filter(function(i) {
                                return $library.find('.resource-item[data-id=' + $(this).data('id') + ']').length == 0;
                            }).get(); // ensure we pass array to isotope

                            $('#pods-paginator .active').removeClass('active');
                            $('#pods-paginator .page-item').eq($html.find('#pods-paginator .active').index()).addClass('active');

                            if ($items.length) {
                                $podList.append($items);

                                iso.appended($items);
                                iso.layout();
                            }
                        };

                    infScroll = new InfiniteScroll($podList[0], scrollOptions);

                    infScroll.on('load', function( body, path, response ) {
                        scrollCallback(body)
                    });

                    // Google analytics push event
                    if (window.ga && typeof window.ga == 'function') {
                        var link = document.createElement('a');
                        $podList.on('append.infiniteScroll', function (event, response, path) {
                            link.href = path;
                            ga('set', 'page', link.pathname);
                            ga('send', 'pageview');
                        });
                    }
                }
            }

            /**
             * Toggle Loading State
             * - Disables form inputs
             * @param bool
             */
            function loadingState(bool) {
                $library.toggleClass('loading', bool);
                $filter.toggleClass('loading', bool);

                $filter.find('.dropdown[data-filter] .dropdown-select, .form-control').toggleClass('disabled', bool).attr('disabled', bool);

                $filter.find('.dropdown.open').removeClass('open');
            }

            /**
             * Update pagination links with filters
             */
            function updatePagination() {
                var params = '';
                for(var type in filters) {
                    if (type == 'search' && filters.search) {
                        params += 'filter_search=' + filters.search;
                    } else {
                        for (var i = 0; i < filters[type].length; i++) {
                            if (filters[type][i]) {
                                params += (params ? '&' : '');
                                if (type == 'type') {
                                    params += 'filter_type%5B%5D=';
                                } else {
                                    params += 'filter_category%5B%5D=';
                                }
                                params += filters[type][i];
                            }
                        }
                    }
                }

                $library.find('#pods-paginator a').each(function () {
                    var urlparts= this.href.split('?')
                    if (urlparts.length) {
                        $(this).attr('href', urlparts[0] + '?' + urlparts[1] + '&' + params);
                    } else {
                        $(this).attr('href', this.href + '?' + params);
                    }
                })

                setupScrolling()
            }

            /**
             * Remove Filter
             */
            function removeFilter() {
                var $self = $(this);
                var $input = $self.prev();
                var type = $input.data('type');
                var value = parseInt($input.val(), 10);

                $self.parent().remove();

                if (filters[type]) {
                    var pos = filters[type].indexOf(value);
                    if (pos !== -1) {
                        filters[type].splice(pos, 1);
                    }
                }

                setFilterValue(type, '');

                updateFilterFields();

                updateFilterDropdowns();

                iso.arrange({ filter: filterSelector, sortBy: 'date', sortAscending: false });

                // Show option
                $filter.find('.dropdown[data-filter="' + type + '"] .dropdown-filter > [data-value="' + $input.val() + '"]').removeClass('hide');

                fetchFilterRequest();
            }

            /**
             * Change Filter
             */
            function changeFilter(e) {
                e.preventDefault();
                var $self = $(this);
                var $dropdown = $self.parents('.dropdown');
                var type = $dropdown.data('filter');
                var value = parseInt($self.data('value'), 10);

                setFilterValue(type, value)

                updateFilterFields();

                updateFilterDropdowns();

                iso.arrange({ filter: filterSelector, sortBy: 'date', sortAscending: false });

                // Reset option + hide selected from options
                $dropdown.find(".dropdown-filter > [data-value='" + $self.data('value') + "']").addClass('hide');

                fetchFilterRequest();
            }

            /**
             *
             * @param callback
             */
            function fetchFilterRequest(callback) {
                var minDelay = $.Deferred();
                var minSecondDelay = 1000;
                setTimeout(function () {
                    minDelay.resolve();
                }, minSecondDelay);

                $('#resource-library-featured:visible').slideUp('fast')

                loadingState(true);

                // ajax update paging
                var form_data = {};

                var $filter_search = $filter.find('input[name=filter_search]');
                if ($filter_search.val()) {
                    form_data['filter_search'] = $filter_search.val();
                }

                var $filter_type = $filter.find('input[name="filter_type[]"]');
                if ($filter_type.length) {
                    form_data['filter_type'] = [];
                    $filter_type.each(function () {
                        form_data['filter_type'].push(this.value);
                    })
                }

                var $filter_category = $filter.find('input[name="filter_category[]"]');
                if ($filter_category.val()) {
                    form_data['filter_category'] = [];
                    $filter_category.each(function () {
                        form_data['filter_category'].push(this.value);
                    })
                }

                // ajax
                filterRequest = $.ajax({
                    type: 'GET',
                    url: location.protocol + '//' + location.host + location.pathname,
                    data: form_data,
                    beforeSend: function () {
                        if (filterRequest !== null) {
                            filterRequest.abort();
                        }
                    }
                });

                $.when(filterRequest, minDelay).then(function (data) {
                    loadingState(false);

                    var $html = $(data[0]);

                    if ($html.length) {
                        // Remove duplicates
                        var $items = $html.find('#resource-library .resource-item').filter(function (i) {
                            return $library.find('.resource-item[data-id=' + $(this).data('id') + ']').length == 0;
                        }).get(); // ensure we pass array to isotope

                        if ($items.length) {
                            $podList.append($items);

                            iso.appended($items);
                        }

                        iso.layout();

                        // replace pagination
                        $library.find('#pods-paginator').html($html.find('#pods-paginator').html());

                        // update total
                        $('#resource-count').text($html.find('#resource-count').text());

                        // Clear if already setup
                        if (infScroll) {
                            infScroll.destroy();
                        }

                        setupScrolling();
                    }

                    if (typeof callback === 'function') {
                        callback();
                    }
                })

            }

            /**
             * Filter types/categories
             * - Valid match if on their own or both together
             * @param obj
             * @returns boolean
             */
            function filterSelector() {
                var matching_search = null;
                var obj = this;
                if (filters.search) {
                    var $elm_title = $(obj).find('.title');
                    if ($elm_title && $elm_title.length) {
                        matching_search = true;

                        $elm_title.each(function() {
                            // Case insensitive search
                            var search_text = $(obj).text().toLowerCase();
                            if (search_text && search_text.indexOf(filters.search.toLowerCase()) === -1) {
                                matching_search = false
                            }

                            if (matching_search && $(obj).next('p')) {
                                var search_text = $(obj).next().text().toLowerCase();
                                if (search_text && search_text.indexOf(filters.search.toLowerCase()) === -1) {
                                    matching_search = false;
                                }
                            }
                        })
                    }
                }

                var matching_type = null;
                if (filters.type && filters.type.length) {
                    matching_type = false;
                    for (var i = 0; i < filters.type.length; i++) {
                        if (obj.classList.contains('type-' + filters.type[i])) {
                            matching_type = true;
                        }
                    }
                }

                var matching_category = null;
                for (var prop in filters) {
                    if (prop == 'type' || prop == 'search') continue;
                    if (filters[prop] && filters[prop].length) {
                        matching_category = false;
                        for (var i = 0; i < filters[prop].length; i++) {
                            if (obj.classList.contains('category-' + prop + '-' + filters[prop][i])) {
                                matching_category = true;
                            }
                        }
                    }
                }

                // All false
                if (matching_search === false || matching_type === false || matching_category === false) {
                    return false; // search/type failed
                }
                return true;
            }

            /**
             * Update Filter Dropdowns
             */
            function updateFilterDropdowns() {
                // Set combinations on available categories/types
                var combinations = { 'categories' : [], 'types' : [] };

                $filter_result.find("input[name='filter_category[]'], input[name='filter_type[]']").each(function() {
                    var $input = $(this);
                    var type = $input.data('type');

                    var $filter_option = $filter.find(".dropdown[data-filter='" + type + "'] .dropdown-filter > [data-value='" + $input.val() + "']");

                    switch (type) {
                        case 'search':
                            break;
                        case 'type':
                            var categories = $filter_option.data('categories');
                            if (categories) {
                                categories = categories.split(',');
                                for(var i = 0; i < categories.length; i++) {
                                    if (combinations['categories'].indexOf(categories[i]) === -1) {
                                        combinations['categories'].push(parseInt(categories[i], 10))
                                    }
                                }
                            }
                            break;
                        default:
                            var content_types = $filter_option.data('content-types');
                            if (content_types) {
                                if (typeof content_types === 'number') {
                                    if (combinations['types'].indexOf(content_types) === -1) {
                                        combinations['types'].push(parseInt(content_types, 10))
                                    }
                                } else if (typeof content_types === 'string') {
                                    content_types = content_types.split(',');
                                    for(var i = 0; i < content_types.length; i++) {
                                        if (combinations['types'].indexOf(content_types[i]) === -1) {
                                            combinations['types'].push(parseInt(content_types[i], 10))
                                        }
                                    }
                                }
                            }

                            break;
                    }
                })

                $filter.find('.dropdown').each(function() {
                    var $dropdown = $(this);
                    var type = ($dropdown.data('filter') == 'type') ? 'types' : 'categories';

                    var $filter_items = $dropdown.find('.dropdown-filter > [data-value]');

                    $filter_items.each(function () {
                        var value = parseInt($(this).data('value'), 10);

                        // Check not in filters
                        if (typeof filters[$dropdown.data('filter')] === 'undefined' || filters[$dropdown.data('filter')].indexOf(value) === -1) {

                            // Check exists
                            if (combinations[type].length == 0) {
                                $(this).removeClass('hide')
                            } else {
                                // Final check
                                var in_combination = (combinations[type].indexOf(value) === -1) ? true : false;
                                $(this).toggleClass('hide', in_combination)
                            }
                        }
                    })
                })
            }

            //
            // Initilizing
            //
            function init() {
                setupScrolling();

                // Setup filter first load
                $filter_result.find("input[name='filter_category[]'], input[name='filter_type[]']").each(function() {
                    var $input = $(this);
                    var type = $input.data('type');
                    var value = parseInt($input.val(), 10);

                    // Hide option if already selected
                    var $filter_option = $filter.find(".dropdown[data-filter='" + type + "'] .dropdown-filter > [data-value='" + $input.val() + "']");
                    $filter_option.addClass('hide');

                    setFilterValue(type, value)
                })

                updateFilterDropdowns();

                // Change filter
                $filter.find('.dropdown-filter > [data-value]').on('click', changeFilter);

                // Remove filter
                $filter_result.find('.remove-btn').on('click', removeFilter)

                // Search
                $('#filter-search-collapse').each(function() {
                    var $searchInput = $(this).find('input[name=filter_search]');
                    var $searchInputClear = $(this).find('.form-control-clear');

                    $(this).on('shown', function() {
                        $searchInput.focus()
                    }).on('hidden', function() {
                        $searchInput.blur()
                    });

                    var searchInputTimer = null;
                    var searchInputValue = null;

                    function changeSearchInput() {
                        if (searchInputValue != this.value) {
                            searchInputValue = this.value;

                            setFilterValue('search', this.value);

                            fetchFilterRequest(function () {
                                iso.arrange({ filter: filterSelector, sortBy: 'date', sortAscending: false });
                            });

                            if (this.value) {
                                $searchInput.next('.form-control-clear').removeClass('hide')
                            } else {
                                $searchInput.next('.form-control-clear').addClass('hide')
                            }
                        }
                    }

                    // Search change
                    $searchInput.on('change', changeSearchInput)

                    // Search type with 1s timer delay
                    $searchInput.on('input', function () {
                        if (searchInputTimer !== null) {
                            clearTimeout(searchInputTimer);
                        }

                        if (this.value.length >= 3) {
                            searchInputTimer = setTimeout(function () {
                                changeSearchInput.apply($searchInput.get(0))
                            }, 500)
                        }
                    })

                    // Clear button
                    $searchInputClear.on('click', function() {
                        $searchInput.val('')

                        if (searchInputTimer !== null) {
                            clearTimeout(searchInputTimer);
                        }

                        changeSearchInput.apply($searchInput.get(0))
                    })
                })

                // Hide resource library otherwise move into resources
                $('#resource-library-featured').each(function () {
                    if ($filter_result.find('.filter-item').length == 0) {
                        $(this).insertAfter('#resource-library .filter-list').removeClass('hide');
                    }
                })

                loadingState(false);
                // Fininshed init
            } // init

            // if filter run update
            function hasCategoryFilter () {
                for (var type in filters) {
                    if (type == 'type' || type == 'search') continue;
                    for (var i = 0; i < filters[type].length; i++) {
                        if (filters[type][i]) {
                            return true;
                        }
                    }
                }
            }

            // Run update before init if (type or category)
            if ((filters.type && filters.type.length) || hasCategoryFilter()) {

                // set original filter for Isotope
                iso.arrange({ filter: filterSelector, sortBy: 'date', sortAscending: false });

                updateFilterFields();

                fetchFilterRequest(function(){
                    init()
                });
            } else {
                updatePagination();
                init()
            }
        }); // end #resource-library
    }); // end docReady

})(jQuery);
